import { useEffect, useState } from 'react';

import { getStorageItem, setStorageItem } from './storage';

const STORAGE_KEY = '@eskolare/menu-collapsed';

export default function useCollapsedNav() {
  // States
  const [isNavCollapsed, setIsNavCollapsed] = useState(() => getStorageItem(STORAGE_KEY, false));

  // Actions
  const setNavCollapsed = value => {
    setIsNavCollapsed(value);
    setStorageItem(STORAGE_KEY, value);
  };

  // Effects
  useEffect(() => {
    const handleStorage = event => {
      if (event.key !== STORAGE_KEY) return;

      setIsNavCollapsed(getStorageItem(STORAGE_KEY, false));
    };

    window.addEventListener('storage', handleStorage);

    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return [isNavCollapsed, setNavCollapsed];
}
